import React, { useState, useEffect } from 'react';
import { BarChart3, TrendingUp, RefreshCw, Download, Loader2 } from 'lucide-react';
import { API } from '../../config/apiBase';


export default function ReportsPage() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [period, setPeriod] = useState('30d');

    const token = localStorage.getItem('token');
    const headers = { 'Authorization': `Bearer ${token}` };

    useEffect(() => {
        (async () => {
            try {
                const res = await fetch(`${API}/performance/summary`, { headers });
                if (res.ok) setData(await res.json());
            } catch {} finally { setLoading(false); }
        })();
    }, []);

    if (loading) return <div className="sv-page"><div className="sv-card-system sv-empty-state"><Loader2 className="animate-spin" /><p className="sv-empty-state-title">Carregando...</p></div></div>;

    const d = data || {};

    return (
        <div className="sv-page" data-testid="reports-page">
            <div className="flex items-center justify-between flex-wrap gap-3">
                <div>
                    <h2 className="text-lg font-bold" style={{ color: 'var(--text)', fontFamily: "var(--font-display)" }}>Performance</h2>
                    <p className="text-xs" style={{ color: 'var(--muted)' }}>Metricas e relatórios de desempenho</p>
                </div>
                <div className="flex gap-2">
                    <div className="sv-tabs" style={{ padding: 2 }}>
                        {[['7d', '7 dias'], ['30d', '30 dias'], ['90d', '90 dias']].map(([k, l]) => (
                            <button key={k} className={`sv-tab ${period === k ? 'active' : ''}`} onClick={() => setPeriod(k)} style={{ padding: '4px 10px', fontSize: 11 }}>{l}</button>
                        ))}
                    </div>
                    <button className="sv-btn-system" onClick={() => window.location.reload()}><RefreshCw size={14} /></button>
                </div>
            </div>

            <div className="sv-kpi-grid">
                <div className="sv-kpi"><span className="sv-kpi-label">Campanhas</span><span className="sv-kpi-value">{d.campaigns || 0}</span></div>
                <div className="sv-kpi"><span className="sv-kpi-label">Enviados</span><span className="sv-kpi-value">{(d.total_sent || 0).toLocaleString('pt-BR')}</span></div>
                <div className="sv-kpi"><span className="sv-kpi-label">Cliques</span><span className="sv-kpi-value">{(d.total_clicks || 0).toLocaleString('pt-BR')}</span></div>
                <div className="sv-kpi"><span className="sv-kpi-label">Taxa Conversao</span><span className="sv-kpi-value">{d.conversion_rate || '0.0%'}</span></div>
            </div>

            <div className="sv-bento-grid">
                <div className="sv-card-system">
                    <div className="sv-card-header"><span className="sv-card-label">Resumo Operacional</span></div>
                    <div className="flex flex-col gap-3">
                        <MetricRow label="Conexões Online" value={d.connections_online || 0} />
                        <MetricRow label="Automações Ativas" value={d.automations_active || 0} />
                        <MetricRow label="Total Ofertas" value={d.deals_total || 0} />
                    </div>
                </div>

                <div className="sv-card-system">
                    <div className="sv-card-header"><span className="sv-card-label">Evolucao de Envios</span></div>
                    <div className="flex items-end gap-1" style={{ height: 160, padding: '0 8px' }}>
                        {[30, 45, 35, 60, 55, 70, 65, 80, 75, 90, 85, 88].map((v, i) => (
                            <div key={i} className="flex-1 rounded-t-md" style={{
                                height: `${v}%`, background: `linear-gradient(180deg, var(--sv-gold-primary) 0%, rgba(var(--sv-accent-rgb), 0.3) 100%)`,
                                opacity: 0.7 + i * 0.025, minWidth: 8, transition: 'height 0.5s ease'
                            }} />
                        ))}
                    </div>
                    <div className="flex justify-between mt-2 px-2">
                        {['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'].map(m => (
                            <span key={m} className="text-[10px]" style={{ color: 'var(--muted-2)' }}>{m}</span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

function MetricRow({ label, value }) {
    return (
        <div className="flex items-center justify-between py-3" style={{ borderBottom: '1px solid var(--border)' }}>
            <span className="text-sm" style={{ color: 'var(--muted)' }}>{label}</span>
            <span className="text-sm font-bold" style={{ color: 'var(--text)' }}>{value}</span>
        </div>
    );
}
